import { useState } from 'react'
import { useCallback } from 'react'

const useForm = (initialValues = {}) => {
  const [values, setValues] = useState(initialValues)

  const handleChange = event => {
    event.persist()
    setValues(values => ({
      ...values,
      [event.target.name]: event.target.value
    }))
  }

  const setValue = useCallback(newValues => {
    setValues(values => ({ ...values, ...newValues }))
  }, [])

  return [values, handleChange, setValue]
}

export default useForm
